import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "ai-copilot-container"
};
const _hoisted_2 = {
  class: "copilot-header"
};
const _hoisted_3 = {
  class: "header-buttons"
};
const _hoisted_4 = {
  class: "copilot-content"
};
const _hoisted_5 = {
  key: 0,
  class: "history-panel"
};
const _hoisted_6 = {
  class: "history-list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "history-item-content"
};
const _hoisted_9 = {
  class: "history-item-title"
};
const _hoisted_10 = {
  class: "history-item-time"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  key: 0,
  class: "empty-history"
};
const _hoisted_13 = {
  key: 1,
  class: "welcome-area"
};
const _hoisted_14 = {
  class: "prompt-cards"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "prompt-icon"
};
const _hoisted_17 = {
  class: "prompt-content"
};
const _hoisted_18 = {
  class: "prompt-title"
};
const _hoisted_19 = {
  class: "prompt-desc"
};
const _hoisted_20 = {
  key: 2,
  class: "chat-area"
};
const _hoisted_21 = {
  class: "copilot-input"
};
const _hoisted_22 = {
  class: "input-wrapper"
};
const _hoisted_23 = {
  class: "input-actions"
};
const _hoisted_24 = ["disabled"];
import { ref, onMounted, inject, h } from 'vue';
import { Bubble } from 'ant-design-x-vue';
import { getAIResponse } from '../services/api.js';
import marked from 'marked';

// 导入图标已移除，使用emoji替代

// 从App组件注入copilotOpen状态和toggleAICopilot方法

export default {
  __name: 'AICopilot',
  setup(__props) {
    const toggleAICopilot = inject('toggleAICopilot');
    const loading = ref(false);
    const messages = ref([]);
    const showWelcome = ref(true);
    const inputValue = ref('');
    const showHistory = ref(false);

    // 鼠标光晕效果
    const mouseGlow = ref({
      x: 0,
      y: 0,
      active: false
    });
    const handleMouseMove = e => {
      const rect = e.currentTarget.getBoundingClientRect();
      mouseGlow.value = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
        active: true
      };
    };
    const handleMouseLeave = () => {
      mouseGlow.value.active = false;
    };

    // 快捷提示卡片数据
    const quickPrompts = [{
      icon: '🔥',
      title: '市场分析',
      description: '当前是否适合进场？'
    }, {
      icon: '⚠️',
      title: '市场风险',
      description: '当前市场风险分析'
    }, {
      icon: '💡',
      title: '个股诊断',
      description: '帮我分析这只股票'
    }];

    // 对话历史管理
    const conversations = ref([]);
    const currentConversationId = ref(null);

    // 生成唯一ID
    const generateId = () => Date.now().toString(36) + Math.random().toString(36).substr(2);

    // 配置marked选项
    marked.setOptions({
      breaks: true,
      gfm: true,
      headerIds: false
    });

    // 消息渲染函数，支持Markdown
    // ✅ 正确的messageRender：接收content字符串（ant-design-x-vue文档标准）
    const messageRender = content => {
      if (!content || content.trim() === '') {
        return h('div', {
          class: 'loading-tip'
        }, 'AI正在思考...');
      }
      // 解析文档支持的Markdown格式
      const renderedContent = marked.parse(content);
      return h('div', {
        class: 'message-content',
        innerHTML: renderedContent
      });
    };

    // 防抖函数，用于优化前端更新频率
    const debounce = (func, wait) => {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };

    // 创建新对话
    const createNewConversation = () => {
      const newConversation = {
        id: generateId(),
        title: '新对话',
        messages: [],
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      conversations.value.unshift(newConversation);
      currentConversationId.value = newConversation.id;
      return newConversation;
    };

    // 切换对话
    const switchConversation = conversationId => {
      const conversation = conversations.value.find(c => c.id === conversationId);
      if (conversation) {
        // 保存当前对话的消息
        if (currentConversationId.value) {
          const currentConv = conversations.value.find(c => c.id === currentConversationId.value);
          if (currentConv) {
            currentConv.messages = messages.value ? [...messages.value] : [];
          }
        }

        // 切换到新对话
        currentConversationId.value = conversationId;
        messages.value = conversation.messages ? [...conversation.messages] : [];
        showWelcome.value = messages.value.length === 0;
        inputValue.value = '';
        showHistory.value = false;
      }
    };

    // 删除对话
    const deleteConversation = (conversationId, event) => {
      event.stopPropagation();
      conversations.value = conversations.value.filter(c => c.id !== conversationId);
      if (currentConversationId.value === conversationId) {
        if (conversations.value.length > 0) {
          switchConversation(conversations.value[0].id);
        } else {
          messages.value = [];
          showWelcome.value = true;
          currentConversationId.value = null;
        }
      }
    };

    // 更新对话标题
    const updateConversationTitle = (conversationId, firstMessage) => {
      const conversation = conversations.value.find(c => c.id === conversationId);
      if (conversation && conversation.title === '新对话') {
        // 使用消息的前20个字符作为标题
        conversation.title = firstMessage.substring(0, 20) + (firstMessage.length > 20 ? '...' : '');
      }
    };
    onMounted(() => {
      // 初始化时创建一个新对话
      createNewConversation();
    });
    const handleSend = async value => {
      const message = typeof value === 'string' ? value : inputValue.value;
      if (!message.trim()) return;

      // 确保有当前对话
      if (!currentConversationId.value) {
        createNewConversation();
      }
      showWelcome.value = false;

      // 1. 添加用户消息
      messages.value.push({
        content: message,
        role: 'user',
        timestamp: new Date().toLocaleTimeString()
      });

      // 更新对话标题（如果是第一条消息）
      const conversation = conversations.value.find(c => c.id === currentConversationId.value);
      if (conversation && conversation.messages.length === 0) {
        updateConversationTitle(currentConversationId.value, message);
      }
      inputValue.value = '';

      // 2. 创建AI消息占位，记录索引（核心！用索引强制更新）
      messages.value.push({
        content: '',
        role: 'assistant',
        timestamp: new Date().toLocaleTimeString(),
        typing: true
      });
      const aiMsgIndex = messages.value.length - 1;
      loading.value = true;
      try {
        // 3. 调用流式API，用索引强制更新数组项
        // 创建防抖的更新函数，避免频繁更新导致性能问题
        const updateMessage = debounce(() => {
          // 强制触发数组响应式
          messages.value = [...messages.value];
        }, 50); // 50ms防抖

        await getAIResponse(message, messages.value.slice(0, -1), chunk => {
          // 核心修复：直接更新消息内容，Vue会监听到变化
          if (messages.value[aiMsgIndex]) {
            messages.value[aiMsgIndex].content += chunk;
            // 使用防抖函数更新UI
            updateMessage();
          }
        });
        // 完成后设置typing为false
        if (messages.value[aiMsgIndex]) {
          messages.value[aiMsgIndex].typing = false;
        }
        // 最后一次更新，确保内容完全渲染
        messages.value = [...messages.value];

        // 更新对话的更新时间和消息
        if (conversation) {
          conversation.messages = [...messages.value];
          conversation.updatedAt = new Date().toISOString();
        }
      } catch (error) {
        console.error('发送失败:', error);
        messages.value.splice(aiMsgIndex, 1, {
          ...messages.value[aiMsgIndex],
          content: '抱歉，AI服务暂时不可用，请稍后重试。'
        });
        messages.value = [...messages.value];

        // 更新对话的消息
        if (conversation) {
          conversation.messages = [...messages.value];
        }
      } finally {
        loading.value = false;
      }
    };

    // 新建对话函数
    const handleNewChat = () => {
      // 保存当前对话的消息
      if (currentConversationId.value) {
        const currentConv = conversations.value.find(c => c.id === currentConversationId.value);
        if (currentConv) {
          currentConv.messages = [...messages.value];
        }
      }

      // 创建新对话
      createNewConversation();
      messages.value = [];
      showWelcome.value = true;
      inputValue.value = '';
    };

    // 切换历史面板显示
    const toggleHistory = () => {
      showHistory.value = !showHistory.value;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "copilot-wrapper",
        onMousemove: handleMouseMove,
        onMouseleave: handleMouseLeave
      }, [_createElementVNode("div", {
        class: "mouse-glow",
        style: _normalizeStyle(mouseGlow.value.active ? {
          left: mouseGlow.value.x + 'px',
          top: mouseGlow.value.y + 'px',
          opacity: 1
        } : {
          opacity: 0
        })
      }, null, 4), _createElementVNode("div", _hoisted_2, [_cache[7] || (_cache[7] = _createStaticVNode("<div class=\"copilot-title\" data-v-5f933f50><div class=\"ai-avatar\" data-v-5f933f50><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-brain\" data-v-5f933f50><path d=\"M12 2a8 8 0 0 0-8 8v12l8-5 8 5V10a8 8 0 0 0-8-8z\" data-v-5f933f50></path><path d=\"M12 2v20\" data-v-5f933f50></path></svg></div><h3 data-v-5f933f50>AI资管助手</h3></div>", 1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
        class: "header-button",
        onClick: handleNewChat,
        title: "新建对话"
      }, [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        class: "lucide lucide-plus"
      }, [_createElementVNode("path", {
        d: "M12 5v14"
      }), _createElementVNode("path", {
        d: "M5 12h14"
      })], -1)]))]), _createElementVNode("button", {
        class: "header-button",
        onClick: toggleHistory,
        title: "对话历史"
      }, [...(_cache[5] || (_cache[5] = [_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        class: "lucide lucide-message-square"
      }, [_createElementVNode("path", {
        d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
      })], -1)]))]), _createElementVNode("button", {
        class: "header-button close-button",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(toggleAICopilot) && _unref(toggleAICopilot)(...args)),
        title: "关闭"
      }, [...(_cache[6] || (_cache[6] = [_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        class: "lucide lucide-x"
      }, [_createElementVNode("path", {
        d: "M18 6 6 18"
      }), _createElementVNode("path", {
        d: "m6 6 12 12"
      })], -1)]))])])]), _createElementVNode("div", _hoisted_4, [showHistory.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
        class: "history-header"
      }, [_cache[9] || (_cache[9] = _createElementVNode("h4", null, "对话历史", -1)), _createElementVNode("button", {
        class: "close-history",
        onClick: toggleHistory
      }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        class: "lucide lucide-x"
      }, [_createElementVNode("path", {
        d: "M18 6 6 18"
      }), _createElementVNode("path", {
        d: "m6 6 12 12"
      })], -1)]))])]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conversations.value, conversation => {
        return _openBlock(), _createElementBlock("div", {
          key: conversation.id,
          class: _normalizeClass(['history-item', {
            active: conversation.id === currentConversationId.value.value
          }]),
          onClick: $event => switchConversation(conversation.id)
        }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(conversation.title), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(new Date(conversation.updatedAt).toLocaleString()), 1)]), _createElementVNode("button", {
          class: "delete-conversation",
          onClick: $event => deleteConversation(conversation.id, $event),
          title: "删除对话"
        }, [...(_cache[10] || (_cache[10] = [_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-trash-2\" data-v-5f933f50><path d=\"M3 6h18\" data-v-5f933f50></path><path d=\"M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6\" data-v-5f933f50></path><path d=\"M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2\" data-v-5f933f50></path><line x1=\"10\" x2=\"10\" y1=\"11\" y2=\"17\" data-v-5f933f50></line><line x1=\"14\" x2=\"14\" y1=\"11\" y2=\"17\" data-v-5f933f50></line></svg>", 1)]))], 8, _hoisted_11)], 10, _hoisted_7);
      }), 128)), conversations.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 暂无对话历史 ")) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), showWelcome.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "welcome-header"
      }, [_createElementVNode("h2", null, "你好，我是 AI 资管助手"), _createElementVNode("p", null, "今天想聊点什么？")], -1)), _createElementVNode("div", _hoisted_14, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(quickPrompts, (prompt, index) => {
        return _createElementVNode("div", {
          key: index,
          class: "prompt-card",
          onClick: $event => handleSend(prompt.description)
        }, [_createElementVNode("div", _hoisted_16, _toDisplayString(prompt.icon), 1), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(prompt.title), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(prompt.description), 1)])], 8, _hoisted_15);
      }), 64))])])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_unref(Bubble).List, {
        items: messages.value,
        roles: {
          user: {
            placement: 'end',
            variant: 'filled',
            shape: 'round',
            styles: {
              content: {
                backgroundColor: '#F5F7F9',
                borderRadius: '8px',
                padding: '12px 16px',
                maxWidth: '80%',
                fontSize: '15px'
              },
              avatar: {
                width: '40px',
                height: '40px',
                borderRadius: '8px',
                backgroundColor: '#E5E7EB',
                color: '#333',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              },
              footer: {
                fontSize: '11px',
                color: '#999',
                marginTop: '4px'
              }
            }
          },
          assistant: {
            placement: 'start',
            variant: 'borderless',
            shape: 'round',
            messageRender: messageRender,
            styles: {
              content: {
                padding: '6px 2px',
                maxWidth: '100%'
              },
              avatar: {
                width: '40px',
                height: '40px',
                borderRadius: '8px',
                backgroundColor: '#2563EB',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              },
              footer: {
                fontSize: '11px',
                color: '#999',
                marginTop: '4px'
              }
            }
          }
        },
        "item-props": item => ({
          typing: item.typing
        })
      }, null, 8, ["items", "roles", "item-props"])]))]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => inputValue.value = $event),
        onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers($event => handleSend(inputValue.value), ["prevent"]), ["enter"])),
        placeholder: "请输入指令，例如：帮我分析市场...",
        class: "custom-input",
        rows: "1"
      }, null, 544), [[_vModelText, inputValue.value]]), _createElementVNode("div", _hoisted_23, [_cache[13] || (_cache[13] = _createStaticVNode("<button class=\"action-btn\" title=\"语音输入\" data-v-5f933f50><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-5f933f50><path d=\"M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z\" data-v-5f933f50></path><path d=\"M19 10v2a7 7 0 0 1-14 0v-2\" data-v-5f933f50></path><line x1=\"12\" x2=\"12\" y1=\"19\" y2=\"22\" data-v-5f933f50></line></svg></button>", 1)), _createElementVNode("button", {
        class: _normalizeClass(["send-btn", {
          active: inputValue.value.trim()
        }]),
        onClick: _cache[3] || (_cache[3] = $event => handleSend(inputValue.value)),
        disabled: !inputValue.value.trim() || loading.value
      }, [...(_cache[12] || (_cache[12] = [_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, [_createElementVNode("line", {
        x1: "22",
        x2: "11",
        y1: "2",
        y2: "13"
      }), _createElementVNode("polygon", {
        points: "22 2 15 22 11 13 2 9 22 2"
      })], -1), _createElementVNode("span", null, "发送", -1)]))], 10, _hoisted_24)])])])], 32)]);
    };
  }
};